export default "__VITE_ASSET__DSs3qJ2U__"